<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
        Cenniki
        <div class="mb-6 flex justify-between items-center">
          <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('price_lists.create')">
            <span>Nowy</span>
            <span class="hidden md:inline">cennik</span>
          </inertia-link>
        </div>
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Rodzaj</th>
          <th class="px-6 pt-6 pb-4">Ukryty</th>
          <th class="px-6 pt-6 pb-4">Obowiązuje od dnia</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Obowiązuje do dnia</th>
        </tr>
        <tr v-for="price_list in price_lists" :key="price_list.id" class="focus-within:bg-gray-100" :class="{'hover:bg-gray-100':!price_list.is_hidden_on_lists,'bg-red-50 hover:bg-red-100':price_list.is_hidden_on_lists}">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('price_lists.edit', price_list.id)">
              {{ price_list.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('price_lists.edit', price_list.id)">
              {{ price_list.type.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('price_lists.edit', price_list.id)">
              {{ price_list.is_hidden_on_lists ? 'Tak' : 'Nie' }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('price_lists.edit', price_list.id)">
              {{ price_list.active_from }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('price_lists.edit', price_list.id)">
              {{ price_list.active_to }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <span class="px-4 flex items-center">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </span>
          </td>
        </tr>
        <tr v-if="price_lists.length === 0">
          <td class="border-t px-6 py-4" colspan="5">Brak określonych cenników.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Cenniki' },
  components: {
    Icon
  },
  layout: Layout,
  props: {
    price_lists: Array
  },
  data() {
    return {
    }
  }
}
</script>
